export interface Funcionalidade {
  slug: string;
  titulo: string;
  subtitulo: string;
  foco: string;
  plano: string;
  planoSlug: string;
  ctaTexto: string;
  ctaLink: string;
  grupo: string;
  comoAjuda: string[];
  paraQuem: string[];
  oQueAcompanha: string[];
  faq: { pergunta: string; resposta: string }[];
  fraseGanho: string;
  fraseDisponibilidade: string;
}

export const grupos = [
  { nome: 'Começar e registrar', descricao: 'Para quem quer começar a registrar e organizar' },
  { nome: 'Acompanhar com mais profundidade', descricao: 'Para quem quer acompanhar cada projeto com mais profundidade' },
  { nome: 'Organizar a parte comercial', descricao: 'Para quem vende e quer organizar a parte comercial' },
];

export const funcionalidades: Funcionalidade[] = [
  {
    slug: 'registro-de-projetos',
    titulo: 'Registro de projetos artesanais',
    subtitulo: 'Acompanhe cada peça desde o início, com mais clareza sobre o que foi feito, o que falta e como o projeto está evoluindo.',
    foco: 'Mostrar valor do registro estruturado',
    plano: 'Presente no plano Light',
    planoSlug: 'light',
    ctaTexto: 'Começar grátis',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'Você organiza cada projeto com nome, técnica e anotações desde o início.',
      'Consegue visualizar o andamento de todas as suas peças em um só lugar.',
      'Evita esquecer detalhes importantes sobre o que já foi feito.',
      'Ganha mais controle sobre o que está em produção e o que já foi concluído.',
    ],
    paraQuem: [
      'Quem trabalha com artesanato e quer sair das anotações soltas.',
      'Quem tem vários projetos ao mesmo tempo e precisa de organização.',
      'Quem está começando e quer criar o hábito de registrar o processo.',
    ],
    oQueAcompanha: [
      'Nome e descrição do projeto',
      'Técnica utilizada',
      'Status do projeto (em andamento, concluído, arquivado)',
      'Data de início e notas livres',
    ],
    faq: [
      { pergunta: 'Preciso pagar para registrar projetos?', resposta: 'Não. O registro de projetos está disponível gratuitamente no plano Light.' },
      { pergunta: 'Quantos projetos posso criar?', resposta: 'No plano Light, você pode criar e acompanhar seus projetos sem limitação.' },
    ],
    fraseGanho: 'Organize seus projetos e tenha clareza sobre cada peça que você cria.',
    fraseDisponibilidade: 'Presente no plano Light - comece grátis.',
  },
  {
    slug: 'controle-de-sessoes',
    titulo: 'Controle de sessões no artesanato',
    subtitulo: 'Registre cada etapa do seu fazer manual e entenda melhor quanto tempo cada projeto realmente pede.',
    foco: 'Leitura do processo',
    plano: 'Presente no plano Light',
    planoSlug: 'light',
    ctaTexto: 'Começar grátis',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'Você registra cada sessão de trabalho de forma simples e rápida.',
      'Consegue entender quanto tempo cada etapa do projeto está demandando.',
      'Ganha mais consciência sobre o ritmo de produção.',
    ],
    paraQuem: [
      'Quem trabalha em projetos longos e quer acompanhar o processo.',
      'Quem quer entender melhor para onde vai o tempo de produção.',
    ],
    oQueAcompanha: [
      'Data e duração de cada sessão',
      'Notas sobre o que foi feito',
      'Histórico básico por projeto',
    ],
    faq: [
      { pergunta: 'Como registro uma sessão?', resposta: 'Basta abrir o projeto, adicionar uma nova sessão com a data e a duração. Simples e rápido.' },
    ],
    fraseGanho: 'Registre seu processo e entenda melhor o tempo que cada peça pede.',
    fraseDisponibilidade: 'Presente no plano Light - comece grátis.',
  },
  {
    slug: 'tempo-por-projeto',
    titulo: 'Tempo por projeto no artesanato',
    subtitulo: 'Tenha uma visão mais clara do tempo dedicado a cada peça e valorize melhor o seu processo.',
    foco: 'Percepção de tempo investido',
    plano: 'Presente no plano Light',
    planoSlug: 'light',
    ctaTexto: 'Começar grátis',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'Você visualiza o tempo total investido em cada projeto.',
      'Consegue comparar o tempo entre diferentes peças e técnicas.',
      'Ganha mais base para valorizar seu trabalho.',
    ],
    paraQuem: [
      'Quem quer ter noção real do tempo investido em cada peça.',
      'Quem precifica e quer entender melhor o custo do próprio tempo.',
    ],
    oQueAcompanha: [
      'Tempo total por projeto',
      'Resumo de sessões registradas',
      'Visão geral de andamento',
    ],
    faq: [
      { pergunta: 'O tempo é calculado automaticamente?', resposta: 'Sim, com base nas sessões registradas, o sistema calcula o tempo total investido.' },
    ],
    fraseGanho: 'Entenda o tempo real de cada peça e valorize melhor o seu trabalho.',
    fraseDisponibilidade: 'Presente no plano Light - comece grátis.',
  },
  {
    slug: 'cronometro-artesanal',
    titulo: 'Cronômetro para produção artesanal',
    subtitulo: 'Acompanhe o tempo real investido em cada sessão e transforme registro em leitura mais precisa do seu ritmo.',
    foco: 'Profundidade de acompanhamento',
    plano: 'Disponível a partir do plano Pro',
    planoSlug: 'pro',
    ctaTexto: 'Conhecer o plano Pro',
    ctaLink: '/planos',
    grupo: 'Acompanhar com mais profundidade',
    comoAjuda: [
      'Você inicia e pausa o cronômetro enquanto trabalha.',
      'O tempo é registrado automaticamente na sessão.',
      'Consegue uma leitura mais precisa sem precisar anotar manualmente.',
    ],
    paraQuem: [
      'Quem quer acompanhar o tempo em tempo real.',
      'Quem busca mais precisão no registro de sessões.',
    ],
    oQueAcompanha: [
      'Cronômetro integrado ao projeto',
      'Registro automático de duração',
      'Sessões com tempo real',
    ],
    faq: [
      { pergunta: 'O cronômetro funciona no celular?', resposta: 'Sim, o cronômetro funciona em qualquer dispositivo com acesso ao navegador.' },
    ],
    fraseGanho: 'Acompanhe o tempo real e ganhe mais precisão no seu registro.',
    fraseDisponibilidade: 'Disponível a partir do plano Pro.',
  },
  {
    slug: 'historico-de-sessoes',
    titulo: 'Histórico detalhado de sessões',
    subtitulo: 'Revisite seu processo com mais clareza e acompanhe como cada projeto foi avançando ao longo do tempo.',
    foco: 'Histórico e acompanhamento detalhado',
    plano: 'Disponível a partir do plano Pro',
    planoSlug: 'pro',
    ctaTexto: 'Conhecer o plano Pro',
    ctaLink: '/planos',
    grupo: 'Acompanhar com mais profundidade',
    comoAjuda: [
      'Você acessa o histórico completo de sessões de cada projeto.',
      'Consegue revisitar o que foi feito em cada etapa.',
      'Ganha mais contexto sobre a evolução do trabalho.',
    ],
    paraQuem: [
      'Quem quer manter um registro detalhado do processo.',
      'Quem trabalha em projetos longos e precisa de referência.',
    ],
    oQueAcompanha: [
      'Histórico completo de sessões',
      'Detalhes de cada registro',
      'Linha do tempo do projeto',
    ],
    faq: [
      { pergunta: 'Posso ver sessões antigas?', resposta: 'Sim, o histórico mantém todas as sessões registradas desde o início do projeto.' },
    ],
    fraseGanho: 'Revisite seu processo e acompanhe a evolução de cada peça.',
    fraseDisponibilidade: 'Disponível a partir do plano Pro.',
  },
  {
    slug: 'graficos-do-artesanato',
    titulo: 'Gráficos para acompanhar seu fazer manual',
    subtitulo: 'Transforme seus registros em uma leitura visual mais clara sobre ritmo, tempo investido e andamento dos projetos.',
    foco: 'Leitura visual e acompanhamento mais profundo',
    plano: 'Disponível a partir do plano Pro',
    planoSlug: 'pro',
    ctaTexto: 'Ver o plano Pro',
    ctaLink: '/planos',
    grupo: 'Acompanhar com mais profundidade',
    comoAjuda: [
      'Você visualiza seus dados em gráficos claros e intuitivos.',
      'Consegue identificar padrões no seu ritmo de trabalho.',
      'Ganha uma leitura visual que facilita decisões.',
    ],
    paraQuem: [
      'Quem quer ir além dos números e ter uma visão mais completa.',
      'Quem gosta de acompanhar a evolução de forma visual.',
    ],
    oQueAcompanha: [
      'Gráficos de tempo por projeto',
      'Evolução de sessões ao longo do tempo',
      'Comparativo entre projetos',
    ],
    faq: [
      { pergunta: 'Preciso configurar algo para ver os gráficos?', resposta: 'Não. Os gráficos são gerados automaticamente com base nos seus registros.' },
    ],
    fraseGanho: 'Transforme seus registros em uma leitura visual do seu processo.',
    fraseDisponibilidade: 'Disponível a partir do plano Pro.',
  },
  {
    slug: 'fotos-do-processo',
    titulo: 'Fotos do processo artesanal',
    subtitulo: 'Registre visualmente a evolução de cada peça e acompanhe seu processo com mais contexto e memória.',
    foco: 'Evolução visual',
    plano: 'Disponível a partir do plano Pro',
    planoSlug: 'pro',
    ctaTexto: 'Conhecer o plano Pro',
    ctaLink: '/planos',
    grupo: 'Acompanhar com mais profundidade',
    comoAjuda: [
      'Você adiciona fotos em cada sessão ou etapa do projeto.',
      'Consegue revisitar visualmente a evolução da peça.',
      'Cria um registro visual rico e com memória.',
    ],
    paraQuem: [
      'Quem quer documentar o processo criativo com imagens.',
      'Quem gosta de ver a evolução visual das suas peças.',
    ],
    oQueAcompanha: [
      'Fotos por sessão',
      'Galeria do projeto',
      'Linha do tempo visual',
    ],
    faq: [
      { pergunta: 'Quantas fotos posso adicionar?', resposta: 'O plano Pro permite adicionar fotos em cada sessão para documentar a evolução do projeto.' },
    ],
    fraseGanho: 'Documente visualmente cada etapa e crie memória do seu processo.',
    fraseDisponibilidade: 'Disponível a partir do plano Pro.',
  },
  {
    slug: 'previsao-de-conclusao',
    titulo: 'Previsão de conclusão do projeto',
    subtitulo: 'Acompanhe seu ritmo com mais clareza e tenha uma leitura mais inteligente sobre o tempo de finalização da peça.',
    foco: 'Inteligência e previsão',
    plano: 'Disponível a partir do plano Pro',
    planoSlug: 'pro',
    ctaTexto: 'Conhecer o plano Pro',
    ctaLink: '/planos',
    grupo: 'Acompanhar com mais profundidade',
    comoAjuda: [
      'O sistema analisa seu ritmo e estima quando o projeto pode ser concluído.',
      'Você ganha mais previsibilidade sobre prazos.',
      'Facilita a organização de entregas e encomendas.',
    ],
    paraQuem: [
      'Quem tem prazos e precisa planejar entregas.',
      'Quem quer entender melhor o próprio ritmo de produção.',
    ],
    oQueAcompanha: [
      'Estimativa de conclusão baseada no ritmo',
      'Comparativo com projetos anteriores',
      'Alertas de prazo',
    ],
    faq: [
      { pergunta: 'A previsão é precisa?', resposta: 'A previsão é baseada no seu histórico de sessões. Quanto mais registros, mais precisa ela fica.' },
    ],
    fraseGanho: 'Entenda seu ritmo e planeje melhor suas entregas.',
    fraseDisponibilidade: 'Disponível a partir do plano Pro.',
  },
  {
    slug: 'gestao-de-encomendas',
    titulo: 'CRM de encomendas para artesãs',
    subtitulo: 'Organize pedidos, prazos e andamento dos trabalhos em uma rotina mais estruturada e tranquila.',
    foco: 'Organização comercial do artesanato',
    plano: 'Incluído no plano Avançado',
    planoSlug: 'avancado',
    ctaTexto: 'Conhecer o plano Avançado',
    ctaLink: '/planos',
    grupo: 'Organizar a parte comercial',
    comoAjuda: [
      'Você organiza todos os pedidos em um só lugar.',
      'Consegue acompanhar prazos e status de cada encomenda.',
      'Ganha mais tranquilidade na rotina de entregas.',
    ],
    paraQuem: [
      'Quem recebe encomendas e precisa de organização.',
      'Quem quer ter mais controle sobre prazos e entregas.',
    ],
    oQueAcompanha: [
      'Lista de encomendas ativas',
      'Prazos e status de cada pedido',
      'Histórico de entregas',
    ],
    faq: [
      { pergunta: 'Posso vincular encomendas a projetos?', resposta: 'Sim, cada encomenda pode estar vinculada a um projeto para acompanhamento completo.' },
    ],
    fraseGanho: 'Organize seus pedidos e ganhe mais tranquilidade nas entregas.',
    fraseDisponibilidade: 'Incluído no plano Avançado.',
  },
  {
    slug: 'gestao-de-clientes',
    titulo: 'Gestão de clientes no artesanato',
    subtitulo: 'Acompanhe contatos, histórico e informações importantes para dar mais continuidade ao relacionamento com seus clientes.',
    foco: 'Organização de clientes',
    plano: 'Incluído no plano Avançado',
    planoSlug: 'avancado',
    ctaTexto: 'Ver o plano Avançado',
    ctaLink: '/planos',
    grupo: 'Organizar a parte comercial',
    comoAjuda: [
      'Você cadastra clientes com informações de contato e preferências.',
      'Consegue acessar o histórico de pedidos de cada cliente.',
      'Fortalece o relacionamento e a continuidade do trabalho.',
    ],
    paraQuem: [
      'Quem tem clientes recorrentes e quer manter o relacionamento.',
      'Quem quer organizar contatos e histórico de pedidos.',
    ],
    oQueAcompanha: [
      'Cadastro de clientes',
      'Histórico de encomendas por cliente',
      'Informações de contato e preferências',
    ],
    faq: [
      { pergunta: 'Posso importar meus contatos?', resposta: 'Atualmente, o cadastro é feito manualmente dentro do sistema.' },
    ],
    fraseGanho: 'Organize seus clientes e fortaleça o relacionamento com quem confia no seu trabalho.',
    fraseDisponibilidade: 'Incluído no plano Avançado.',
  },
  {
    slug: 'calculo-de-custo',
    titulo: 'Cálculo de custo no artesanato',
    subtitulo: 'Tenha mais clareza sobre tempo, materiais e composição do valor de cada peça para tomar decisões com mais segurança.',
    foco: 'Leitura de custo',
    plano: 'Presente no plano Light',
    planoSlug: 'light',
    ctaTexto: 'Começar grátis',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'O sistema reúne tempo e materiais para calcular o custo de cada peça.',
      'Você entende melhor a composição do valor do seu trabalho.',
      'Ganha mais segurança para definir preços.',
    ],
    paraQuem: [
      'Quem vende e precisa saber se está cobrando o suficiente.',
      'Quem quer entender o custo real de produção.',
    ],
    oQueAcompanha: [
      'Custo de materiais por projeto',
      'Custo de tempo investido',
      'Custo total estimado',
    ],
    faq: [
      { pergunta: 'O cálculo é automático?', resposta: 'O sistema calcula com base nos materiais e sessões registradas. Quanto mais completo o registro, mais preciso o cálculo.' },
    ],
    fraseGanho: 'Entenda o custo real de cada peça e tome decisões com mais segurança.',
    fraseDisponibilidade: 'Presente no plano Light - comece grátis.',
  },
  {
    slug: 'precificacao-artesanal',
    titulo: 'Precificação artesanal com mais clareza',
    subtitulo: 'Organize melhor sua formação de preço e ganhe mais confiança para entender o valor do seu trabalho.',
    foco: 'Valor e precificação',
    plano: 'Incluído no plano Avançado',
    planoSlug: 'avancado',
    ctaTexto: 'Ver o plano Avançado',
    ctaLink: '/planos',
    grupo: 'Organizar a parte comercial',
    comoAjuda: [
      'O sistema sugere faixas de preço com base nos custos registrados.',
      'Você organiza a formação de preço de forma mais estruturada.',
      'Ganha mais confiança para comunicar o valor do seu trabalho.',
    ],
    paraQuem: [
      'Quem vende artesanato e quer precificar com mais segurança.',
      'Quem sente dificuldade em definir o preço justo das peças.',
    ],
    oQueAcompanha: [
      'Sugestão de preço baseada em custos',
      'Margem de lucro estimada',
      'Comparativo entre peças',
    ],
    faq: [
      { pergunta: 'O sistema define o preço por mim?', resposta: 'Não. O sistema organiza seus dados e sugere faixas. A decisão final é sempre sua.' },
    ],
    fraseGanho: 'Precifique com mais clareza e ganhe confiança para valorizar seu trabalho.',
    fraseDisponibilidade: 'Incluído no plano Avançado.',
  },
  {
    slug: 'relatorios-avancados',
    titulo: 'Relatórios avançados para o artesanato',
    subtitulo: 'Acompanhe sua rotina com uma leitura mais ampla sobre pedidos, números e evolução do seu trabalho.',
    foco: 'Visão gerencial',
    plano: 'Incluído no plano Avançado',
    planoSlug: 'avancado',
    ctaTexto: 'Conhecer o plano Avançado',
    ctaLink: '/planos',
    grupo: 'Organizar a parte comercial',
    comoAjuda: [
      'Você acessa relatórios completos sobre produção, custos e entregas.',
      'Consegue tomar decisões com base em dados concretos.',
      'Ganha uma visão gerencial do seu trabalho artesanal.',
    ],
    paraQuem: [
      'Quem quer ter uma visão mais ampla do negócio.',
      'Quem precisa de dados para planejar e crescer.',
    ],
    oQueAcompanha: [
      'Relatório de produção por período',
      'Relatório de custos e receitas',
      'Relatório de encomendas e clientes',
    ],
    faq: [
      { pergunta: 'Posso exportar os relatórios?', resposta: 'Sim, o plano Avançado permite exportar dados em formatos acessíveis.' },
    ],
    fraseGanho: 'Tenha uma visão completa do seu trabalho e tome decisões com mais clareza.',
    fraseDisponibilidade: 'Incluído no plano Avançado.',
  },
  {
    slug: 'gestao-de-estoque',
    titulo: 'Gestão de Estoque para artesanato',
    subtitulo: 'Organize seus materiais, insumos e ferramentas em um só lugar - com controle de quantidade e alertas de estoque mínimo.',
    foco: 'Controle de materiais',
    plano: 'Presente no plano Light',
    planoSlug: 'light',
    ctaTexto: 'Começar grátis',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'Você cadastra todos os seus materiais com nome, marca, cor e quantidade.',
      'Recebe alertas quando o estoque está abaixo do mínimo definido.',
      'Consegue ter uma visão clara do que tem disponível antes de começar um projeto.',
    ],
    paraQuem: [
      'Quem trabalha com vários tipos de materiais e precisa de organização.',
      'Quem quer evitar compras duplicadas ou falta de insumos.',
    ],
    oQueAcompanha: [
      'Cadastro de materiais com categoria e unidade',
      'Controle de quantidade e estoque mínimo',
      'Alertas de reposição',
    ],
    faq: [
      { pergunta: 'Preciso pagar para usar o estoque?', resposta: 'Não. A gestão de estoque está disponível gratuitamente no plano Light.' },
    ],
    fraseGanho: 'Organize seus materiais e nunca mais perca o controle do que tem disponível.',
    fraseDisponibilidade: 'Presente no plano Light - comece grátis.',
  },
  {
    slug: 'calculadora-de-custos',
    titulo: 'Calculadora de custos do artesanato',
    subtitulo: 'Calcule o custo real de cada peça considerando materiais, tempo e despesas - e saiba exatamente quanto cobrar.',
    foco: 'Precificação e gestão',
    plano: 'Presente no plano Light',
    planoSlug: 'light',
    ctaTexto: 'Conhecer a funcionalidade',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'Você calcula o custo real de cada peça artesanal somando materiais e tempo investido.',
      'Entende quanto custa produzir cada trabalho e evita vender abaixo do preço justo.',
      'No plano Avançado, recebe sugestão de preço de venda com base nos custos reais.',
    ],
    paraQuem: [
      'Quem vende artesanato e quer saber o custo real de cada peça.',
      'Quem quer precificar com mais segurança e parar de adivinhar preços.',
      'Quem busca entender se o trabalho manual está dando retorno financeiro.',
    ],
    oQueAcompanha: [
      'Cálculo de custo de materiais utilizados',
      'Cálculo de tempo investido na produção',
      'Sugestão de preço de venda (plano Avançado)',
    ],
    faq: [
      { pergunta: 'Qual a diferença entre planos?', resposta: 'No Light e Pro você calcula o custo. No Avançado, recebe também uma sugestão de preço de venda.' },
    ],
    fraseGanho: 'Saiba exatamente quanto custa cada peça - e quanto cobrar por ela.',
    fraseDisponibilidade: 'Presente no plano Light.',
  },
  {
    slug: 'iarisco-geracao-com-ia',
    titulo: 'IArisco - riscos com inteligência artificial',
    subtitulo: 'Transforme uma foto em um risco limpo, pronto para bordar, pintar ou colorir, em poucos segundos com inteligência artificial.',
    foco: 'Geração de riscos com IA',
    plano: 'Disponível em todos os planos',
    planoSlug: 'light',
    ctaTexto: 'Começar grátis',
    ctaLink: '/cadastro',
    grupo: 'Começar e registrar',
    comoAjuda: [
      'Você envia uma foto e recebe um risco em traço limpo, pronto para usar.',
      'Ajusta o nível de detalhe e a espessura do traço conforme a peça que vai produzir.',
      'Exporta o resultado em PNG ou PDF, no tamanho ideal para impressão e transferência.',
      'Ganha tempo no início do projeto sem precisar redesenhar a imagem manualmente.',
    ],
    paraQuem: [
      'Quem borda, pinta ou trabalha com técnicas que exigem um risco como base.',
      'Quem perde tempo desenhando referências à mão a partir de uma foto.',
      'Quem quer testar variações de estilo antes de começar a produzir.',
    ],
    oQueAcompanha: [
      'Upload de imagem (JPG, PNG ou WEBP)',
      'Ajustes de detalhe e espessura de traço',
      'Exportação em PNG e PDF (tamanhos prontos para impressão, incluindo A4)',
      'Histórico das gerações realizadas',
    ],
    faq: [
      { pergunta: 'Quem pode usar o IArisco?', resposta: 'Está disponível em todos os planos. Light recebe 1 crédito inicial, Pro 2 créditos por mês e Avançado 3 créditos por mês.' },
      { pergunta: 'Posso comprar mais créditos?', resposta: 'Sim. Existem pacotes avulsos de créditos que não expiram e podem ser comprados a qualquer momento.' },
      { pergunta: 'O risco gerado serve para impressão em A4?', resposta: 'Sim. A exportação em PDF já vem em formato pronto para impressão, incluindo opção em folha A4 e tamanhos personalizados.' },
      { pergunta: 'Que tipos de imagem funcionam melhor?', resposta: 'Fotos com boa iluminação, foco nítido e elemento principal bem destacado geram riscos mais limpos e fáceis de trabalhar.' },
    ],
    fraseGanho: 'Transforme suas fotos em riscos prontos para produzir, em poucos segundos.',
    fraseDisponibilidade: 'Disponível em todos os planos - comece grátis.',
  },
  {
    slug: 'vitrine-artesa',
    titulo: 'Vitrine Artesã - sua página pública de produtos',
    subtitulo: 'Crie uma página pública personalizada para mostrar seus produtos, captar leads pelo WhatsApp e receber listas de interesse - sem complicação técnica.',
    foco: 'Presença digital e captação de leads',
    plano: 'Incluído no plano Avançado',
    planoSlug: 'avancado',
    ctaTexto: 'Conhecer o plano Avançado',
    ctaLink: '/planos',
    grupo: 'Organizar a parte comercial',
    comoAjuda: [
      'Você cria uma página pública com seu próprio link (artesa-app.com.br/vitrine/seu-nome).',
      'Personaliza cores, fonte, logo e identidade visual conforme a sua marca.',
      'Cadastra produtos com foto, preço e descrição em poucos minutos.',
      'Recebe leads pelo WhatsApp e listas de interesse direto no seu painel.',
      'Compartilha o link em redes sociais, cartões e mensagens sem precisar de site próprio.',
    ],
    paraQuem: [
      'Quem vende artesanato e quer ter uma presença pública sem precisar montar um site.',
      'Quem usa Instagram ou WhatsApp como canal principal e quer um link organizado para enviar.',
      'Quem deseja captar leads de forma simples, sem se preocupar com pagamento online.',
    ],
    oQueAcompanha: [
      'Página pública com link personalizado',
      'Cadastro de produtos com foto, preço e descrição',
      'Formulário de captação de leads (nome, WhatsApp, mensagem)',
      'Lista de interesse (tipo carrinho, sem pagamento)',
      'Painel com todos os leads recebidos e status de leitura',
      'Personalização de cores, fonte e logo',
    ],
    faq: [
      { pergunta: 'A vitrine processa pagamentos?', resposta: 'Não. A vitrine é focada em geração de leads. O pagamento e os detalhes da venda são combinados diretamente entre você e o cliente, pelo WhatsApp.' },
      { pergunta: 'Posso desativar a vitrine quando quiser?', resposta: 'Sim. A qualquer momento você pode marcar como inativa. Quando desativada, o link público mostra "vitrine não encontrada".' },
      { pergunta: 'Posso mudar meu link depois?', resposta: 'Sim, desde que o novo link esteja disponível. Mas evite trocar com frequência para não perder acessos antigos.' },
      { pergunta: 'A vitrine está em qual plano?', resposta: 'Está incluída no plano Avançado, junto com os outros recursos comerciais como CRM, encomendas e precificação assistida.' },
    ],
    fraseGanho: 'Tenha uma página pública profissional para mostrar seus produtos e captar leads, sem precisar de site próprio.',
    fraseDisponibilidade: 'Incluído no plano Avançado.',
  },
];
